// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.applicant.ApplicantsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { GetApplicantsForPropertyApplicationIdWebApiResponseDto } from '../..';

interface GetApplicantsForPropertyApplicationIdParams {
  applicationId: string;
  listingAlias: string;
}

export const ApplicantsWebApiHandler_getApplicantsForPropertyApplicationId_Path =
  '/api/web/v1/applicant/getApplicantsForPropertyApplicationId';

/**
 * get applicants for a property by applicationId
 */
export const ApplicantsWebApiHandler_getApplicantsForPropertyApplicationId = (
  getParams: GetApplicantsForPropertyApplicationIdParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    GetApplicantsForPropertyApplicationIdParams,
    never,
    GetApplicantsForPropertyApplicationIdWebApiResponseDto
  >(
    {
      getParams: getParams,
      endpoint: ApplicantsWebApiHandler_getApplicantsForPropertyApplicationId_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};
